import { useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  return useDataChange({
    context: 'filters',
    viewPath: props.viewPath,
  })
}
